import * as types from '../../action-types';
import {updateLanguage as initialState } from "../../initialState";

const updateLanguage = (state=initialState, action) => {
  switch (action.type) {
    case types.UPDATE_LANGUAGE_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_LANGUAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPDATE_LANGUAGE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_LANGUAGE_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default updateLanguage;
